// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingInvoiceResponse

import { BillingInvoiceStatus } from './enums.gen';
import { hydrateBillingInvoicePayment, type BillingInvoicePayment, type BillingInvoicePaymentApiResponse } from './billingInvoicePayment.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type BillingInvoiceApiResponse = {
	id: number;
	amount: number;
	status: BillingInvoiceStatus;
	paymentInProgress: boolean;
	date: string;
	payments: BillingInvoicePaymentApiResponse[];
};

export type BillingInvoice = {
	id: number;
	amount: number;
	status: BillingInvoiceStatus;
	paymentInProgress: boolean;
	date: DateTime;
	payments: BillingInvoicePayment[];
};

export function hydrateBillingInvoice(data: BillingInvoiceApiResponse): BillingInvoice {
	return {
		...data,
		date: DateTimefromISO(data.date)!,
		payments: data.payments.map(hydrateBillingInvoicePayment),
	};
}